module.exports = __webpack_public_path__ + "static/Heebo-Regular-e4693fd854aac78779b91428d717b90f.ttf";